import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Check from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { navigate } from 'utils/navigate';

interface UpgradePlanCardProps {
  title: React.ReactNode;
}

export const UpgradePlanCard: React.FC<UpgradePlanCardProps> = ({ title }) => {
  const { t } = useTranslation();

  const handleUpgradePlan = () => {
    navigate('/settings/plan');
  };

  return (
    <Card>
      <CardContent sx={{ width: '360px' }} data-testid="upgrade-plan-card">
        <Stack mb={2}>{title}</Stack>
        <iframe
          width="100%"
          height="200"
          src="https://www.youtube.com/embed/HFFus-VBgR8"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
        <Typography fontSize="20px" fontWeight={600} variant="h5" pb="12px" mt={2}>
          {t('share_document_v3.automatic_reminders.automatic_document_expiry.upgrade_plan_card_title')}
        </Typography>
        <Stack spacing={1} mb={3}>
          {(t('share_document_v3.automatic_reminders.automatic_document_expiry.features_list', { returnObjects: true }) as string[]).map(
            (feature: string, index: number) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                <Check htmlColor="#41B97D" sx={{ mr: 1 }} />
                <Typography fontSize="16px" fontWeight={400} variant="body1">
                  {feature}
                </Typography>
              </Box>
            )
          )}
        </Stack>
        <Button variant="contained" onClick={handleUpgradePlan} fullWidth>
          {t('share_document_v3.automatic_reminders.automatic_document_expiry.upgrade_plan_card_button')}
        </Button>
      </CardContent>
    </Card>
  );
};
